import { get } from 'lodash';
import moment from 'moment';

// import case names
import { updateMemberManagementStateAction, clearMemberManagementStateAction } from 'store/actions/updateMemberManagementState';

// local dependencies
import { getStore } from 'store';
import { REDUCER } from 'constants/entity-names';

// get store
const store = getStore();

/**
 * @type {function}
 * @desc Resolvers are pure functions used for resolving templates (React components) or to transform some data.
 * A resolver function takes an `id` and an optional `payload` and returns a `result`.
 * Based on `switch` cases inside this function, correct `result` should be returned.
 * @param {object} payload
 * @example
 * import { updateMemberManagementState } from 'resolvers/memberManagementState';
 */
export const updateMemberManagementState = ( { memberId, patientId, liveFallback = false } ) => {

    // capture current timestamp
    const timestamp = moment().format();

    const memberManagementState = {
        ...store.getState()[ REDUCER.MEMBER_MANAGEMENT_STATE ],
        memberId,
        patientId,
        liveFallback: true === liveFallback,
        timestamp
    };

    return store.dispatch( updateMemberManagementStateAction( memberManagementState ) );
};

/**
 * @type {function}
 * import { clearMemberManagementState } from 'resolvers/memberManagementState';
 */
export const clearMemberManagementState = () => {
    return store.dispatch( clearMemberManagementStateAction() );
};

/**
 * @type {function}
 * import { getMemberManagementState } from 'resolvers/memberManagementState';
 */
export const getMemberManagementState = () => {
    const memberId = get( store.getState()[ REDUCER.MEMBER_MANAGEMENT_STATE ], 'memberId', null );
    const timestamp = get( store.getState()[ REDUCER.MEMBER_MANAGEMENT_STATE ], 'timestamp', null );

    return {
        memberId,
        patientId: get( store.getState()[ REDUCER.MEMBER_MANAGEMENT_STATE ], 'patientId', null ),
        liveFallback: true === get( store.getState()[ REDUCER.MEMBER_MANAGEMENT_STATE ], 'liveFallback', false ),
        timestamp
    };
};
